var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinancy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.5C6 16.3954 6.89543 15.5 8 15.5H23C24.1046 15.5 25 16.3954 25 17.5V38.5C25 39.6046 24.1046 40.5 23 40.5H8C6.89543 40.5 6 39.6046 6 38.5V17.5Z",
    stroke: "#20376A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18.5,
    width: 13,
    height: 3,
    rx: 1,
    stroke: "#20376A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5V6.25C15 6.11193 15.1119 6 15.25 6H31.5M31.5 6L37 11.5M31.5 6V11.5H37M37 11.5V24.5M24.5 11H19.5M29.5 16V18.25C29.5 18.3881 29.6119 18.5 29.75 18.5H32M29.5 22V24.25C29.5 24.3881 29.6119 24.5 29.75 24.5H32",
    stroke: "#BF9C41",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34.6473C42 37.9976 39.1358 40.7947 35.5 40.7947C31.8642 40.7947 29 37.9976 29 34.6473C29 31.2971 31.8642 28.5 35.5 28.5C39.1358 28.5 42 31.2971 42 34.6473Z",
    stroke: "#BF9C41",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8569 36.1155C37.8569 36.607 37.6906 37.0287 37.3581 37.3806C37.0257 37.726 36.5991 37.9451 36.0784 38.0381V38.8649C36.0784 38.9977 36.0345 39.1106 35.9467 39.2036C35.8589 39.2966 35.7491 39.343 35.6173 39.343C35.4919 39.343 35.3884 39.2966 35.3068 39.2036C35.2253 39.1106 35.1845 38.9977 35.1845 38.8649V38.068C34.8206 38.0348 34.4882 37.9518 34.1871 37.8189C33.8922 37.6861 33.6099 37.4869 33.3402 37.2213C33.2084 37.1017 33.1426 36.9656 33.1426 36.8128C33.1426 36.6933 33.1865 36.587 33.2743 36.4941C33.3621 36.3945 33.4656 36.3446 33.5848 36.3446C33.6915 36.3446 33.7824 36.3812 33.8577 36.4542C34.071 36.6535 34.2812 36.8128 34.4882 36.9324C34.7015 37.0453 34.9336 37.1183 35.1845 37.1515V34.8504C34.5823 34.7043 34.1181 34.4752 33.7919 34.1631C33.4719 33.8443 33.312 33.4127 33.312 32.8681C33.312 32.3435 33.4845 31.9085 33.8295 31.5632C34.1745 31.2178 34.6262 31.0086 35.1845 30.9356V30.4276C35.1845 30.2947 35.2253 30.1818 35.3068 30.0889C35.3946 29.9959 35.5044 29.9494 35.6362 29.9494C35.7616 29.9494 35.8651 29.9959 35.9467 30.0889C36.0345 30.1818 36.0784 30.2947 36.0784 30.4276V30.9555C36.3733 31.002 36.6461 31.085 36.8971 31.2045C37.148 31.3241 37.355 31.4702 37.5181 31.6428C37.6624 31.7757 37.7345 31.9184 37.7345 32.0712C37.7345 32.1907 37.6906 32.297 37.6028 32.39C37.5212 32.4829 37.4209 32.5294 37.3017 32.5294C37.2139 32.5294 37.1417 32.5029 37.0853 32.4497C36.9723 32.3368 36.8249 32.2306 36.643 32.131C36.4674 32.0313 36.2792 31.955 36.0784 31.9018V34.1133C36.6806 34.2793 37.126 34.5117 37.4146 34.8106C37.7094 35.1028 37.8569 35.5378 37.8569 36.1155ZM34.2059 32.8283C34.2059 33.0939 34.2874 33.3097 34.4505 33.4758C34.6199 33.6351 34.8646 33.768 35.1845 33.8742V31.862C34.8771 31.9151 34.6356 32.028 34.4599 32.2007C34.2906 32.3734 34.2059 32.5825 34.2059 32.8283ZM36.0784 37.1017C36.3419 37.022 36.552 36.8992 36.7089 36.7331C36.872 36.5671 36.9535 36.3745 36.9535 36.1554C36.9473 35.903 36.872 35.6938 36.7277 35.5278C36.5834 35.3551 36.367 35.2124 36.0784 35.0995V37.1017Z",
    fill: "#BF9C41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 24.5V26.5C9.5 26.7761 9.72386 27 10 27H11",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.5V26.5C15 26.7761 15.2239 27 15.5 27H16.5",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 29.5V31.5C9.5 31.7761 9.72386 32 10 32H11",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 34.5V36.5C9.5 36.7761 9.72386 37 10 37H11",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.5V31.5C15 31.7761 15.2239 32 15.5 32H16.5",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30V36.5C20 36.7761 20.2239 37 20.5 37H22",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.5V36.5C15 36.7761 15.2239 37 15.5 37H16.5",
    stroke: "#20376A",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5V26.5C20 26.7761 20.2239 27 20.5 27H21.5",
    stroke: "#20376A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancy);
export default __webpack_public_path__ + "static/media/Financy.9cd9a7a9dc57d383d41576033ec29454.svg";
export { ForwardRef as ReactComponent };